import React, { useState, useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import Header from './components/header';
import Footer from './components/footer';
import CookieBanner from './components/cookie-banner';
import AgeModal from './components/age-modal';
import Home from './pages/home';
import About from './pages/about';
import Contact from './pages/contact';
import Help from './pages/help';
import PrivacyPolicy from './pages/privacy-policy';
import CookiePolicy from './pages/cookie-policy';
import HowWeReview from './pages/how-we-review';
import ResponsibleGambling from './pages/responsible-gambling';

function App() {
  const [showAgeModal, setShowAgeModal] = useState(false);
  const [showCookieBanner, setShowCookieBanner] = useState(false);

  useEffect(() => {
    const ageVerified = localStorage.getItem('ageVerified');
    const cookiesAccepted = localStorage.getItem('cookiesAccepted');
    
    if (!ageVerified) {
      setShowAgeModal(true);
    }
    if (!cookiesAccepted) {
      setShowCookieBanner(true);
    }
  }, []);

  const handleAgeConfirm = () => {
    localStorage.setItem('ageVerified', 'true');
    setShowAgeModal(false);
  };

  const handleCookieAccept = () => {
    localStorage.setItem('cookiesAccepted', 'true');
    setShowCookieBanner(false);
  };

  return (
    <div className="app">
      {showAgeModal && <AgeModal onConfirm={handleAgeConfirm} />}
      <Header />
      <section className="global-safety-banner">
        <div className="container">
          <div className="global-safety-content">
            <span className="global-safety-pill">18+ ONLY</span>
            <p>
              Gambling can be addictive. Set limits, never chase losses, and play responsibly.
              If you need support call <strong>0808 8020 133</strong> or visit <a href="https://www.gambleaware.org/" target="_blank" rel="noopener noreferrer">GambleAware</a>.
            </p>
            <a href="/responsible-gambling" className="global-safety-link">Responsible Gambling Help</a>
          </div>
        </div>
      </section>
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/help" element={<Help />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/cookie-policy" element={<CookiePolicy />} />
          <Route path="/how-we-review" element={<HowWeReview />} />
          <Route path="/responsible-gambling" element={<ResponsibleGambling />} />
        </Routes>
      </main>
      <Footer />
      {showCookieBanner && <CookieBanner onAccept={handleCookieAccept} />}
    </div>
  );
}

export default App;
